const OPFS_ROOT = "attachdrive/blobs";

async function getDir(path: string): Promise<FileSystemDirectoryHandle> {
  const root = await navigator.storage.getDirectory();
  const parts = path.split("/").filter(Boolean);
  let dir = root;
  for (const part of parts) {
    dir = await dir.getDirectoryHandle(part, { create: true });
  }
  return dir;
}

export async function writeBlob(documentId: string, blob: Blob): Promise<string> {
  const dir = await getDir(OPFS_ROOT);
  const fileName = `${documentId}`;
  const fileHandle = await dir.getFileHandle(fileName, { create: true });
  const writable = await fileHandle.createWritable();
  await writable.write(blob);
  await writable.close();
  return `${OPFS_ROOT}/${fileName}`;
}

export async function readBlob(path: string): Promise<Blob | null> {
  try {
    const parts = path.split("/").filter(Boolean);
    const fileName = parts.pop()!;
    const dirPath = parts.join("/");
    const dir = await getDir(dirPath);
    const fileHandle = await dir.getFileHandle(fileName);
    const file = await fileHandle.getFile();
    return file;
  } catch {
    return null;
  }
}

export async function deleteBlob(path: string): Promise<void> {
  try {
    const parts = path.split("/").filter(Boolean);
    const fileName = parts.pop()!;
    const dirPath = parts.join("/");
    const dir = await getDir(dirPath);
    await dir.removeEntry(fileName);
  } catch {
    // ignore
  }
}

export async function listBlobs(): Promise<string[]> {
  try {
    const dir = await getDir(OPFS_ROOT);
    const paths: string[] = [];
    for await (const name of (dir as any).keys()) {
      paths.push(`${OPFS_ROOT}/${name}`);
    }
    return paths;
  } catch {
    return [];
  }
}

export async function getOrphanBlobs(): Promise<string[]> {
  const allBlobs = await listBlobs();
  const manifestEntries = await db.opfsManifest.toArray();
  const validPaths = new Set(manifestEntries.map((e) => e.opfsPath));
  return allBlobs.filter((p) => !validPaths.has(p));
}

import { db } from "./db";
